// Mock data for the Document/Contract Signing dashboard (DocuSign-like)

export const contract = {
  value: "68,575",
  currency: "$",
  cents: ".00",
  recipient: "QCell",
  envelopeNumber: "EMP-300",
  status: "Awaiting",
};

export const progress = {
  signed: { label: "Signed", amount: "333" },
  pending: { label: "Pending", amount: "5" },
  balance: { label: "Action Required", amount: "15" },
  daysOutstanding: 8,
};

export const documents = [
  {
    id: 1,
    name: "Master Service Agreement",
    size: "2.4 MB",
    pages: 14,
    type: "PDF",
    color: "#7AFFA1",
  },
  {
    id: 2,
    name: "Non-Disclosure Agreement",
    size: "1.1 MB",
    pages: 6,
    type: "PDF",
    color: "#FFF87C",
  },
  {
    id: 3,
    name: "Statement of Work",
    size: "3.8 MB",
    pages: 22,
    type: "DOCX",
    color: "#DDCBF5",
  },
  {
    id: 4,
    name: "Data Processing Addendum",
    size: "0.9 MB",
    pages: 4,
    type: "PDF",
    color: "#7AFFA1",
  },
  {
    id: 5,
    name: "Terms & Conditions",
    size: "1.6 MB",
    pages: 9,
    type: "DOCX",
    color: "#DDCBF5",
  },
];

export const activities = [
  {
    id: 1,
    title: "Send Signature Reminder",
    date: "12 Feb",
    time: "at 11 pm",
    person: "Jessi Johnson",
    subtitle: "sent a signature reminder",
    avatar:
      "https://i.pravatar.cc/80?img=47",
    bg: "#DDCBF5",
    icon: "calendar",
  },
  {
    id: 2,
    title: "Call about terms",
    date: "13 Feb",
    time: "at 12 pm",
    person: "Brian Carpenter",
    subtitle: "Google Meet",
    avatar:
      "https://i.pravatar.cc/80?img=12",
    bg: "#FFF87C",
    icon: "phone",
  },
];
